export const SCROLL_ANCHOR_PAGE_WRAPPER = "scroll-anchor-page-wrapper"

export const scrollToTop = () => {
  const wrapper = document.getElementById(SCROLL_ANCHOR_PAGE_WRAPPER)
  wrapper?.scrollTo({ top: 0, behavior: "smooth" })
}

export const scrollToElement = (elementId: string, offset = 0) => {
  const wrapper = document.getElementById(SCROLL_ANCHOR_PAGE_WRAPPER)
  const element = document.getElementById(elementId)

  if (!wrapper || !element) {
    return
  }

  const wrapperRect = wrapper.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()

  const elementTop = elementRect.top - wrapperRect.top + wrapper.scrollTop

  wrapper.scrollTo({
    top: Math.max(0, elementTop - offset),
    behavior: "smooth",
  })
}
